import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  PriceConfigService,
  DocumentsService,
  BackendInterceptor,
  AuthService,
  CartService,
  CustomerService,
  GungFlowService,
  GungModalService,
  NavbarConfigService,
  NewsActionConfigService,
  SelectedCustomerService,
  NavAction,
  NavGroup,
  NavLink,
  BaseViewConfigService,
  Customer
} from 'gung-standard';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ColmecNavbarConfigService extends NavbarConfigService {
  enableDigitalAssets = true;
  enableActivityInternal = true;

  protected getSalesMenu(isActuator?: boolean, roles?: string[]): (NavLink | NavAction | NavGroup)[] {
    const baseMenu: NavGroup[] = super.getSalesMenu(isActuator, roles);
    baseMenu[0].links.push({
      link: '/claims',
      heading: 'CLAIMS'
      // icon: 'fa-user'
    });
    baseMenu[0].links.push({
      link: '/activity-internal',
      heading: 'ACTIVITIES'
      // icon: 'fa-user'
    });
    baseMenu[0].links.push({
      link: '/partner-agreements',
      queryParams: {
        filters: 'STATUS__:__ACTIVE'
      },
      queryParamsHandling: '',
      heading: 'PARTNER_AGREEMENTS'
    });
    baseMenu[0].links.push({
      link: '/work-orders',
      heading: 'WORK_ORDERS'
    });
    return baseMenu;
  }

  protected getUserMenu(
    customer: Customer,
    isSales?: boolean,
    customers?: number,
    isActuator?: boolean
  ): (NavLink | NavAction | NavGroup)[] {
    const baseMenu: NavGroup[] = super.getUserMenu(customer, isSales, customers, isActuator);

    // baseMenu[0].links.push({
    //   link: '/claims',
    //   heading: 'CLAIMS',
    //   // icon: 'fa-user'
    // });
    return baseMenu;
  }

  protected getAdminMenu(isActuator: boolean): (NavLink | NavAction | NavGroup)[] {
    const baseMenu: NavGroup[] = super.getAdminMenu(isActuator);
    if (isActuator) {
      baseMenu[1].links.push({
        link: '/partner-agreements',
        queryParams: {
          filters: 'STATUS__:__ACTIVE'
        },
        queryParamsHandling: '',
        heading: 'PARTNER_AGREEMENTS'
      });

      // baseMenu[1].links.push({
      //   link: '/working-order',
      //   heading: 'WORKING_ORDER'
      // });

      baseMenu[1].links.push({
        link: '/work-orders',
        heading: 'WORK_ORDERS'
      });

      baseMenu[1].links.push({
        link: '/tire-policy',
        heading: 'TIRE_POLICY_LIST'
      });
    }
    return baseMenu;
  }
}
